import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { FadeIn } from './ui/FadeIn';
import { Globe } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen w-full overflow-hidden bg-[#2D1B4E] text-white pt-20 pb-16 lg:pt-32 lg:pb-24" data-id="element-64">
      {/* Background ambient glow */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-65">
        <div className="absolute top-[-10%] right-[-10%] w-[500px] h-[500px] rounded-full bg-[#D4A574] opacity-10 blur-[100px]" data-id="element-66" />
        <div className="absolute bottom-[-10%] left-[-10%] w-[600px] h-[600px] rounded-full bg-[#E8D5D5] opacity-10 blur-[120px]" data-id="element-67" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-68">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-69">
          {/* Content */}
          <div className="flex-1 max-w-2xl text-center lg:text-left" data-id="element-70">
            <FadeIn delay={0.1} data-id="element-71">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 text-sm font-medium text-[#E8D5D5] mb-8" data-id="element-72">
                <Globe className="h-4 w-4" data-id="element-73" />
                <button className="hover:text-white transition-colors" data-id="element-74">
                  View in English
                </button>
                <span className="opacity-50" data-id="element-75">|</span>
                <button className="hover:text-white transition-colors" data-id="element-76">
                  Ver en Español
                </button>
              </div>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-77">
              <h1 className="text-4xl md:text-5xl lg:text-7xl font-bold leading-tight mb-6 tracking-tight" data-id="element-78">
                From Trauma to <br data-id="element-79" />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#D4A574] to-[#E8D5D5]" data-id="element-80">
                  Self-Love
                </span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-81">
              <h2 className="text-xl md:text-2xl text-[#E8D5D5] font-light mb-8 italic" data-id="element-82">
                Shadow Work Secrets: A Modern Guide to Shadow Integration and
                Emotional Freedom
              </h2>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-83">
              <p className="text-lg text-gray-300 mb-10 leading-relaxed max-w-xl mx-auto lg:mx-0" data-id="element-84">
                You've done the work. You've read the books. Maybe you've even
                gone to therapy. But something still feels unfinished—like
                you're carrying something heavy inside. This book meets you
                right there—where understanding ends, and integration begins.
              </p>
            </FadeIn>

            <FadeIn delay={0.5} data-id="element-85">
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4" data-id="element-86">
                <Button size="lg" withIcon href="https://www.dreambuk.com/cart/45563104067770:1" data-id="element-87">
                  Get Instant Access – $7.99
                </Button>
                <p className="text-sm text-gray-400 mt-2 sm:mt-0" data-id="element-88">
                  Instant PDF Download
                </p>
              </div>
            </FadeIn>
          </div>

          {/* Image */}
          <div className="flex-1 w-full max-w-[500px] lg:max-w-none" data-id="element-89">
            <FadeIn delay={0.4} direction="left" data-id="element-90">
              <motion.div animate={{
              y: [0, -15, 0]
            }} transition={{
              duration: 6,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="relative" data-id="element-91">
                <div className="absolute inset-0 bg-gradient-to-tr from-[#D4A574] to-[#2D1B4E] rounded-2xl blur-2xl opacity-30 transform scale-95 translate-y-4" data-id="element-92" />
                <img src="https://cdn.magicpatterns.com/uploads/3NrgeHMH1zxC1jhh8TEW3X/heylloyd-image-1770228763545.png" alt="From Trauma to Self-Love Book on Tablet" className="relative rounded-2xl shadow-2xl w-full h-auto border border-white/10" data-id="element-93" />
              </motion.div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}